import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import './i18n';
import { SnackbarProvider } from 'notistack';
import Loader from './components/loader';
import persistStore from 'redux-persist/es/persistStore';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundaryWithTranslation from 'ErrorBoundaryWithTranslation';
// import NoInternetConnection from "./components/no-internet/NoInternet";
let persistor = persistStore(store);
const App = lazy(
  () => import('./components/app/index' /* webpackChunkName: "App" */),
);




// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <>
    {/* <NoInternetConnection> */}
    <SnackbarProvider
      maxSnack={10}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={3000}
      preventDuplicate
    >
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Suspense fallback={<Loader isLoading={true} />}>
          <ErrorBoundaryWithTranslation>
            <App />
          </ErrorBoundaryWithTranslation>
          </Suspense>
        </PersistGate>
      </Provider>
    </SnackbarProvider>
    {/* </NoInternetConnection> */}
  </>,
  document.getElementById('root'),
);

/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();